import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'recrewt-footer-only-layout',
  templateUrl: './footer-only-layout.component.html',
  styleUrls: ['./footer-only-layout.component.scss'],
  imports: [RouterOutlet, FooterComponent],
})
export class FooterOnlyLayoutComponent {}
